import { FC } from 'react';
import { ButtonBase, Typography } from '@mui/material';
import { TrancheDotColor } from '../dotColors';
import { Cached } from '@mui/icons-material';
import { styled } from '@mui/material/styles';
import { Row } from 'further-ui/components/Layout';
import Dot from 'further-ui/components/Dot';

const WhiteCached = styled(Cached)(({ theme }) => ({
  color: theme.palette.common.white,
}));

const OpenTrancheButton = styled(ButtonBase)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(theme.spacingSizes.xxs),
}));

type Props = {
  isPublishable: boolean;
  onOpenTranche: () => void;
};

const DraftTrancheBanner: FC<Props> = ({ isPublishable, onOpenTranche }) => {
  if (isPublishable) {
    return (
      <Row spacing="xxs" centered justify="center">
        <Typography variant="inherit" color="grey.500">
          You can now open this tranche.
        </Typography>
        <OpenTrancheButton onClick={onOpenTranche}>
          <Typography variant="h6" color="common.white">
            Switch to open
          </Typography>
          <WhiteCached fontSize="small" />
        </OpenTrancheButton>
      </Row>
    );
  }

  return (
    <Row spacing="xs" centered justify="center">
      To open this tranche, complete all required steps.{' '}
      <Dot size={8} color={TrancheDotColor.Draft} />
    </Row>
  );
};

export default DraftTrancheBanner;
